import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledTimeFrameInput = styled('div')`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 4px;
  border-radius: 4px;
  box-sizing: border-box;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  background-color: ${(props) => {
    if (props.hasError) return COLOR.functionalRed[8];
    if (props.isEditing) return COLOR.secondary[40];
    return 'transparent';
  }};
  border: ${(props) => {
    if (props.hasError) return `1px solid ${COLOR.redPrimary}`;
    if (props.isEditing) return `1px solid ${COLOR.darkBlue}`;
    return '1px solid transparent';
  }};

  &:hover {
    background-color: ${(props) => {
      if (props.disabled) return 'transparent';
      if (props.hasError) return COLOR.functionalRed[8];
      return COLOR.secondary[40];
    }};
  }

  .time-display {
    font-family: 'SF Pro Text', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: rgba(28, 28, 30, 0.64);
    white-space: nowrap;
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  }

  input {
    font-family: 'SF Pro Text', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: rgba(28, 28, 30, 0.64);
    border: none;
    outline: none;
    background: transparent;
    padding: 0;
    margin: 0;
    field-sizing: content;
    &:disabled {
      cursor: not-allowed;
    }
  }

  .error-icon {
    color: ${COLOR.redPrimary};
    font-size: 16px;
    cursor: pointer;
  }
`;

export const StyledTimeFrameRow = styled('div')`
  display: flex;
  align-items: center;
  gap: 2px;
  margin-bottom: 4px;

  .block-index {
    font-family: 'SF Pro Text', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: rgba(28, 28, 30, 0.64);
    padding: 2px;
  }

  .time-separator {
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    letter-spacing: -0.4px;
    color: rgba(28, 28, 30, 0.64);
    padding: 2px;
  }

  .divider {
    font-family: 'SF Pro Text', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: rgba(28, 28, 30, 0.48);
    padding: 2px;
  }

  .voice-info {
    display: flex;
    align-items: center;
    gap: 4px;

    .voice-icon {
      width: 10.67px;
      height: 10.67px;
      color: rgba(28, 28, 30, 1);
    }

    .voice-name {
      font-family: 'SF Pro Text', sans-serif;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.4px;
      color: rgba(28, 28, 30, 0.64);
    }
  }
`;
